module.exports = __webpack_public_path__ + "media/images/emblems/Thunstetten-coat_of_arms-d73776c4784b3ac16291b7ebf87b2b0b.svg";